import * as types from '../types.js';
import { formatLotNumber } from '../../versa/misc.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(n+4):nth-child(-n+20)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(21)	{ text-align: right; }
			.view td:nth-child(n+23):nth-child(-n+25)	{ text-align: right; }
			.view td:nth-child(26)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Estoque</th>
					<th data-index="12" data-visible="${this.visible[2]}">SKU</th>
					<th data-index="13" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="15" data-visible="${this.visible[4]}">Fabricante</th>
					<th data-index="16" data-visible="${this.visible[5]}">NCM</th>
					<th data-index="17" data-visible="${this.visible[6]}">EAN</th>
					<th data-index="18" data-visible="${this.visible[7]}">Cód. cliente</th>
					<th data-index="19" data-visible="${this.visible[8]}">Emb.</th>
					<th data-index="20" data-visible="${this.visible[9]}">Fator</th>
					<th data-index="21" data-visible="${this.visible[10]}">QR Emb.</th>
					<th data-index="23" data-visible="${this.visible[11]}">Programa</th>
					<th data-index="24" data-visible="${this.visible[12]}">Lote fab.</th>
					<th data-index="26" data-visible="${this.visible[13]}">Validade</th>
					<th data-index="25" data-visible="${this.visible[14]}">Fabricação</th>
					<th data-index="28" data-visible="${this.visible[15]}">Data Entrada</th>
					<th data-index="27" data-visible="${this.visible[16]}">Entrada Sial</th>
					<th data-index="29" data-visible="${this.visible[17]}">Nota Entrada</th>
					<th data-index="30" data-visible="${this.visible[18]}">Fornecedor</th>
					<th data-index="3" data-visible="${this.visible[19]}">Armazém</th>
					<th data-index="4" data-visible="${this.visible[20]}">Posição</th>
					<th data-index="5" data-visible="${this.visible[21]}">Titular</th>
					<th data-index="6" data-visible="${this.visible[22]}">Lote</th>
					<th data-index="7" data-visible="${this.visible[23]}">Disponível</th>
					<th data-index="8" data-visible="${this.visible[24]}">Reservado</th>
					<th data-index="9" data-visible="${this.visible[25]}">Bloqueado</th>
					<th data-index="37" data-visible="${this.visible[26]}">Valor unit.</th>
					<th data-index="38" data-visible="${this.visible[27]}">Valor total</th>
				<th data-index="10" data-visible="${this.visible[28]}">Status</th>
			<th data-index="33" data-visible="${this.visible[29]}">Classes</th>
			<th data-index="34" data-visible="${this.visible[30]}">Categoria</th>
			<th data-index="35" data-visible="${this.visible[31]}">Portaria 344</th>
		</tr>
	</thead>
		<tbody>
		` + (await Promise.all(records.map(async record =>
		{
				let posLabel = (record.location_address != null && String(record.location_address).trim() !== '')
					? String(record.location_address)
					: '';
				// Não resolver endereço pelo cache local (IDB): catálogo pode ter posições que a API não devolve na listagem.
				if (!posLabel && record.warehouse_id != null && record.location_id != null)
					posLabel = `${record.warehouse_id}-${record.location_id}`;
				// Nome do armazém vem da API (`warehouse_name`); cache local omite inativos → só key() gerava «undefined».
				let whLabel = (record.warehouse_name != null && String(record.warehouse_name).trim() !== '')
					? String(record.warehouse_name).trim()
					: '';
				if (!whLabel)
					whLabel = await this.key('warehouses', [record.company_id, record.warehouse_id]);
				if (!whLabel && record.warehouse_id != null && record.warehouse_id !== '')
					whLabel = `#${record.warehouse_id}`;
				return `<tr data-id='${JSON.stringify([record.company_id, record.id])}'> <td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.sku ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.product_name ?? '').toString()}</td>
					<td data-visible='${this.visible[4]}'>${(record.manufacturer_nick ?? '').toString()}</td>
					<td data-visible='${this.visible[5]}'>${(record.ncm ?? '').toString()}</td>
					<td data-visible='${this.visible[6]}'>${(record.gtin ?? '').toString()}</td>
					<td data-visible='${this.visible[7]}'>${(record.codigo_cliente ?? '').toString()}</td>
					<td data-visible='${this.visible[8]}'>${(record.packaging_code ?? '').toString()}</td>
					<td data-visible='${this.visible[9]}'>${this.format(types.number(0), record.packaging_factor) ?? ''}</td>
					<td data-visible='${this.visible[10]}'>${(record.packaging_qr_code ?? '').toString()}</td>
					<td data-visible='${this.visible[11]}'>${(record.program_name ?? '').toString()}</td>
					<td data-visible='${this.visible[12]}'>${formatLotNumber(record.lot_number)}</td>
					<td data-visible='${this.visible[13]}'>${record.expiration_date ?? ''}</td>
					<td data-visible='${this.visible[14]}'>${record.manufacture_date ?? ''}</td>
					<td data-visible='${this.visible[15]}'>${this.format(types.date(), record.input_created_on) ?? ''}</td>
					<td data-visible='${this.visible[16]}'>${record.input_id ?? ''}</td>
					<td data-visible='${this.visible[17]}'>${(record.invoice_number ?? '').toString()}</td>
					<td data-visible='${this.visible[18]}'>${(record.supplier_name ?? '').toString()}</td>
					<td data-visible='${this.visible[19]}'>${whLabel ?? ''}</td>
					<td data-visible='${this.visible[20]}'>${posLabel}</td>
					<td data-visible='${this.visible[21]}'>${await this.key('companies', record.lot_company_id, 'nick')}</td>
					<td data-visible='${this.visible[22]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[23]}'>${this.format(types.number(0), record.quantity_available)}</td>
					<td data-visible='${this.visible[24]}'>${this.format(types.number(0), record.quantity_reserved)}</td>
					<td data-visible='${this.visible[25]}'>${this.format(types.number(0), record.quantity_unsettled)}</td>
					<td data-visible='${this.visible[26]}'>${this.format(types.number(4), record.unit_price)}</td>
					<td data-visible='${this.visible[27]}'>${this.format(types.number(2), record.total_value)}</td>
				<td data-visible='${this.visible[28]}'>${this.option(types.opt_stock_status(), record.status)}</td>
			<td data-visible='${this.visible[29]}'>${(record.classes ?? '').toString()}</td>
			<td data-visible='${this.visible[30]}'>${(record.categoria ?? '').toString()}</td>
			<td data-visible='${this.visible[31]}'>${this.option(types.opt_bool(), record.is_portaria_344)}</td>
		</tr>`;
			}
				))).join('') +
			`
			</tbody>
		</table>
	`;
};
